import httpClient from "@/services/index";
import { API_ENDPOINTS } from "./endpoints";

export const downloadImageFromUrl = async (url: string) => {
  const res = await fetch(url);
  if (!res.ok) throw new Error("Failed to fetch image");
  const blob = await res.blob();
  return URL.createObjectURL(blob);
};

export const featureImagesList = async () => {
  const url = API_ENDPOINTS.FEATURE_IMAGES;

  const config = {
    headers: {
      "Content-Type": "application/json",
    },
  };
  return httpClient.post(url, null, config).then((response) => {
    return response.data.data;
  });
};
